import { Toaster as SonnerToaster, toast } from "sonner";

/**
 * Toaster — notifikasi non-blok (sukses scan, item ditahan, error sync).
 * Styling mengikuti token via CSS var sonner. Pesan singkat, dapat
 * ditindaklanjuti (PRODUCT.md tone). Pakai `toast` dari sini.
 */
export function Toaster() {
  return (
    <SonnerToaster
      position="top-center"
      gap={8}
      toastOptions={{
        classNames: {
          toast:
            "z-toast !rounded-md !border !border-border !bg-surface !text-ink !shadow-[var(--shadow-toast)] !font-sans",
          title: "!text-sm !font-medium",
          description: "!text-[0.8125rem] !text-muted",
          actionButton: "!bg-primary !text-primary-ink !rounded-md",
          cancelButton: "!bg-surface-2 !text-ink !rounded-md",
          error: "!text-danger [&_svg]:!text-danger",
          success: "[&_svg]:!text-success",
        },
      }}
    />
  );
}

export { toast };
